module.exports = __webpack_public_path__ + "media/Toy Story 1  Trailer.80b5d5e5.mp4";